import React, {useEffect, useMemo, useState} from "react";
import JobWorkersService from "../../../../../../API/organization/JobWorkersService";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import Box from "@mui/material/Box";
import TextFieldValidation from "../../../customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";
import DateInput from "../../../../filter/DateInput";
import ButtonCreate from "../../../../button/ButtonCreate";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";

const ReportRemainsTable = ({
                                tableOptions,
                                tableOptionsHandle,
                                handleModalAlert,
                                workers,
                                startInitValue,
                                date,
                                setDate
                            }) => {
    const [data, setData] = useState(null);
    const [formState, setFormState] = useState({workerId: "all"});

    const getData = (workerId, date) => {
        JobWorkersService.getReportRemains(workerId, date).then(function (response) {
            const data = response.data;
            tableOptionsHandle((prev) => ({...prev, totalElements: response.data.total}))
            setData(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }
    useEffect(() => {
        applyFilter()
    }, []);

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'worker',
                header: 'Работник',
                accessorKey: 'worker',
                minSize: 500,
                Cell: ({cell}) => {
                    const worker = cell.getValue();

                    if (!worker) {
                        return "Нет данных"; // или любой другой placeholder, например: ""
                    }

                    return `${worker.lastName || ''} ${worker.firstName?.substring(0, 1) || ''}.${worker.middleName?.substring(0, 1) || ''}.`;
                }
            },
            {
                id: 'fullTime',
                header: 'Полное время',
                accessorKey: 'fullTime',
                minSize: 100,
                Cell: ({row}) => row.original.fullTime?.toFixed(3),
            },
            {
                id: 'completion',
                header: 'Выполнено',
                accessorKey: 'completion',
                minSize: 100,
                Cell: ({row}) => row.original.completion?.toFixed(3),
            },
            {
                id: 'shipped',
                header: 'Отгружено',
                accessorKey: 'shipped',
                minSize: 100,
                Cell: ({row}) => row.original.shipped?.toFixed(3),
            },
            {
                id: 'paid',
                header: 'Оплачено',
                accessorKey: 'paid',
                minSize: 100,
                Cell: ({row}) => row.original.paid?.toFixed(3),
            },
            {
                id: 'differenceCompletion',
                header: 'Разница выполнено',
                accessorKey: 'differenceCompletion',
                minSize: 100,
                Cell: ({row}) => row.original.differenceCompletion?.toFixed(3),
            },
            {
                id: 'differenceShipped',
                header: 'Разница отгружено',
                accessorKey: 'differenceShipped',
                minSize: 100,
                Cell: ({row}) => row.original.differenceShipped?.toFixed(3),
            },
            {
                id: 'differencePaid',
                header: 'Разница оплачено',
                accessorKey: 'differencePaid',
                minSize: 100,
                Cell: ({row}) => row.original.differencePaid?.toFixed(3),
            },
        ];

        return baseColumns;

    }, [data, setData]);

    const applyFilter = () => {
        const values = Object.values(date).map(el => DateTimeUtil.convertToJavaDate(el))
        getData(formState.workerId === "all" ? null : formState.workerId, ...values)
    }

    const cancelFilter = (clear) => {
        setDate(prev => ({
            ...prev, reportRemains: {
                startShipped: clear ? null : startInitValue,
            }
        }))
        setFormState({workerId: "all"})
    }

    return (
        <Box sx={{ overflow: 'auto',
            maxWidth: 'calc(100vw - 50px)',width: "2500px"}}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                <Box sx={{display: 'flex', justifyContent: "spase-between", alignItems: "flex-end", gap: "9px"}}>
                    <Box sx={{width: "260px"}}>
                        <TextFieldValidation
                            select
                            name="workerId"
                            label="Работники"
                            value={formState.workerId}
                            setCurrValues={setFormState}
                            height={51}
                        >
                            <MenuItem key={"all"} value={"all"}>
                                Все
                            </MenuItem>
                            {workers?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.lastName} {option.firstName.substr(0, 1)}.{option.middleName.substr(0, 1)}.
                                </MenuItem>
                            ))}
                        </TextFieldValidation>
                    </Box>
                    <Box>
                        <Typography sx={{
                            fontSize: "16px",
                            fontWeight: 700
                        }}>{"Дата"}</Typography>
                        <DateInput
                            value={date.startShipped}
                            setValue={(value) => setDate(prev => ({
                                ...prev, reportRemains: {...prev.reportRemains, startShipped: value},
                            }))}
                            variant={"outlined"}
                        />
                    </Box>
                    <ButtonCreate
                        text={"Применить фильтр"}
                        width={170}
                        height={43}
                        icon={false}
                        onClick={applyFilter}
                    />
                    <ButtonCreate
                        text={"Отменить фильтр"}
                        width={160}
                        height={43}
                        icon={false}
                        onClick={() => cancelFilter(false)}
                    />
                    <ButtonCreate
                        text={"Очистить фильтр"}
                        width={160}
                        height={43}
                        icon={false}
                        onClick={() => cancelFilter(true)}
                    />
                </Box>
            </Box>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale='ru'
                localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableContainerProps={{
                        sx: {
                            width: "2500px",
                            maxHeight: `calc(100vh - 585px)`
                        }
                    }}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "& td:after": {
                                "&:hover": {
                                    backgroundColor: "red"
                                }
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }

                            }
                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem",
                            "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                "minWidth": "100%"
                            }
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}

                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    columns={columns}
                    data={data || []}
                    rowHeight={13}
                    columnSpacing={1}
                    getRowId={(originalRow) => originalRow.id}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    manualPagination={true}
                    state={{showGlobalFilter: true, pagination: tableOptions}}
                    rowCount={tableOptions.totalElements}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                    }}
                    localization={MRT_Localization_RU}
                    enableToolbarInternalActions={false}
                    enableRowActions={false}
                />
            </LocalizationProvider>
        </Box>
    );
};


export default ReportRemainsTable;